import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import OrganizationUrls, {
    ORGANIZATION_CREATE_POST_URL,
    ORGANIZATION_GET_ALL_URL,
} from '../../../constants/private/urls/organization/organization.urls';
import {
    IOrganIn,
    IOrganInMetadata,
    IOrgContext,
    IWorkspacesPaginatedResponse,
} from '../../../models/organization/organization-model';
import { IUpdateOrganizationRequestBody } from '../../http-models/organization/organization-request-model';
import { IOrganizationUserInMD } from '../../../models/organization/organization-user/organization-user-model';
import WorkspaceUrls from '../../../constants/private/urls/workspace/workspace.urls';
import { IPaginationQuery } from '../../../models/defines';

@Injectable()
export class OrganizationApiService {
    constructor(private http: HttpClient) {}

    public createNewOrg$(name: string) {
        return this.http.post<{ organization: IOrganIn; organizationMD: IOrganInMetadata }>(
            ORGANIZATION_CREATE_POST_URL,
            { name: name }
        );
    }

    public getAllOrganizationsMD$() {
        return this.http.get<IOrganInMetadata[]>(ORGANIZATION_GET_ALL_URL);
    }

    public updateOrganizationFields$(orgContext: IOrgContext, body: IUpdateOrganizationRequestBody) {
        const url = OrganizationUrls.getOrganUpdateFieldsPUTUrl(orgContext);
        return this.http.put<IOrganInMetadata>(url, body);
    }

    public getOrganization$(orgContext: IOrgContext) {
        const url = OrganizationUrls.getOrganDetailsGETUrl(orgContext);
        return this.http.get<IOrganIn>(url);
    }

    /// Will be deleted
    public getAllOrganizationUsers$(orgContext: IOrgContext) {
        const url = OrganizationUrls.getAllOrganUsersGETUrl(orgContext);
        return this.http.get<IOrganizationUserInMD[]>(url);
    }

    getWorkspacesPaginated$(orgContext: IOrgContext, options: IPaginationQuery) {
        const url = WorkspaceUrls.getWorkspacesPaginatedGETUrl(orgContext, options);
        return this.http.get<IWorkspacesPaginatedResponse>(url);
    }
}
